import { t } from "i18next";
import { FloorAvailability } from "../../../../features/FloorManager/typings/floor-inventory.entity";
import { getFloorSelectableObjectCount } from "../../functions/getFloorInventoryIdsForSelection.function";

export type GenerateFloorButtonLabelOptions = {
  canBookInactive?: boolean;
};

export const generateFloorButtonLabel = (
  inventory: FloorAvailability[],
  currentFloorIndex = 0,
  options: GenerateFloorButtonLabelOptions = {}
) => {
  const defaultLabel = t("Floor");

  if (!inventory.length) return defaultLabel;

  const selected = inventory[currentFloorIndex];

  if (!selected) return defaultLabel;

  const { canBookInactive = false } = options;

  const selectableCount = getFloorSelectableObjectCount(selected, canBookInactive);

  return t("_booking_floorButton_labelWithAvailable", {
    floorName: selected.name,
    count: selectableCount
  });
};
